import type React from "react"
import { Component } from "react"
import CLASSES from "../constants/classes"
import type { IAllRaces } from "../constants/interfaces"
import RACES from "../icons/races"

interface MyProps {
    onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, race: IAllRaces) => void
}

export default class RaceSelection extends Component<MyProps> {
    /**
     * If a race was selected, clear BOArea and BuildOrder and reset everything
     * Then load the right race in ActionSelection
     */
    // constructor(props) {
    //     super(props)
    // }

    onClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, race: IAllRaces): void => {
        this.props.onClick(e, race)
    }

    render(): React.ReactElement {
        const classString = `${CLASSES.raceIcon}`

        const allRaces: Array<IAllRaces> = ["protoss", "terran", "zerg"]
        const races = allRaces.map((race, _index) => {
            const item: { name: string; path: string } = RACES[race]
            return (
                <button id={race} key={item.name} className={classString} onClick={(e) => this.onClick(e, race)}>
                    <img src={require(`../icons/png/${item.path}`)} alt={item.name} />
                </button>
            )
        })

        return <div className={"flex flex-col"}>{races}</div>
    }
}
